import TeamSpiritMatchTable from './TeamSpiritMatchTable'
import Button from 'react-bootstrap/Button'

const toDateKey = value => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return date.toISOString().slice(0, 10)
}

const TeamSpiritPreviousPhaseMatches = ({
  matches,
  table,
  onSimulate,
  simulationLoading,
}) => {
  const previousMatches = Array.isArray(matches) ? matches : []
  const teamsByName = new Map(
    (Array.isArray(table?.selectedGroup?.teams) ? table.selectedGroup.teams : [])
      .map(team => [String(team?.name || '').trim(), Number(team?.teamId)])
      .filter(([name, teamId]) => name && Number.isFinite(teamId))
  )
  const matchesByDate = previousMatches.reduce((byDate, match) => {
    const dateKey = toDateKey(match?.matchDate)
    if (!dateKey) return byDate
    if (!byDate.has(dateKey)) byDate.set(dateKey, [])
    byDate.get(dateKey).push(match)
    return byDate
  }, new Map())
  const timeline = [...matchesByDate.entries()]
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([dateKey, dateMatches]) => ({
      type: 'match',
      key: `previous-phase-${dateKey}`,
      index: `previous-phase-${dateKey}`,
      date: new Date(`${dateKey}T12:00:00`),
      calendarLabel: `Vaihe ${dateMatches[0]?.phase || '–'}`,
      matchLabel: 'Edellinen vaihe',
      readOnly: true,
      matches: dateMatches,
    }))
  const perCountryByRowKey = Object.fromEntries(
    timeline.map(row => [
      row.key,
      Object.fromEntries(
        (Array.isArray(table?.countryGroups) ? table.countryGroups : []).map(
          country => {
            const teamId = teamsByName.get(country)
            const match = row.matches.find(
              candidate =>
                Number(candidate?.homeTeamId) === teamId ||
                Number(candidate?.awayTeamId) === teamId
            )
            if (!match) return [country, {}]
            const isHome = Number(match.homeTeamId) === teamId
            const simulationDetails =
              match.simulationDetails?.[String(teamId)] || {}
            return [
              country,
              {
                previousPhase: true,
                opponentName: isHome ? match.awayTeamName : match.homeTeamName,
                venue: isHome ? 'Home' : 'Away',
                matchId: match.matchId,
                groupLabel: match.groupLabel,
                formation: simulationDetails.formation || '',
                tactic: simulationDetails.tactic || '',
                midfieldInput: simulationDetails.midfieldInput || '',
                simulationResult: simulationDetails.simulationResult || null,
              },
            ]
          }
        )
      ),
    ])
  )

  if (timeline.length === 0) {
    return (
      <div className="mb-3 text-muted small">
        Edellisen vaiheen otteluita ei löytynyt tämän lohkon joukkueille.
      </div>
    )
  }

  return (
    <div className="mb-3">
      <div className="d-flex align-items-center gap-2 mb-2">
        <h5 className="mb-0">Edellinen vaihe</h5>
        {onSimulate ? (
          <Button
            size="sm"
            variant="outline-danger"
            disabled={simulationLoading}
            onClick={onSimulate}
          >
            {simulationLoading ? 'Simuloidaan...' : 'Simuloi edellisen vaiheen ottelut'}
          </Button>
        ) : null}
      </div>
      <TeamSpiritMatchTable
        table={{
          ...table,
          timeline,
          perCountryByRowKey,
          currentRoundBucket: null,
          nextMatchRowId: null,
        }}
      />
    </div>
  )
}

export default TeamSpiritPreviousPhaseMatches
